import { twMerge } from "tailwind-merge";
import { GoalScope } from "types/graphql-schema";

export const classNames = (
  ...classes: ReadonlyArray<string | boolean | null | undefined>
) => {
  return twMerge(classes.filter(Boolean).join(" "));
};

export const inputBorderClassName = "border border-gray-200 rounded-md";

const inputFocusClassName =
  "focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500";

export const inputClassName = classNames(
  "h-[32px] px-3 block w-full text-sm bg-white disabled:bg-gray-100",
  inputBorderClassName,
  inputFocusClassName,
);

export const inputThemeDefaultClassName = classNames(
  inputClassName,
  inputFocusClassName,
  "bg-white disabled:bg-gray-100 border-gray-200 rounded-md",
);
export const inputThemeTextClassName = classNames(
  inputClassName,
  inputFocusClassName,
  "bg-white hover:bg-gray-100 disabled:bg-white border-transparent rounded-md",
);

export const textareaBorderClassName = inputBorderClassName;
export const textareaClassName = classNames(
  "px-3 py-1.5 block w-full text-sm",
  "disabled:bg-white disabled:hover:bg-white disabled:resize-none placeholder:font-normal",
  textareaBorderClassName,
  inputFocusClassName,
);

export const popoverClassName =
  "absolute w-96 z-dropdown bg-white shadow-lg rounded-md ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none text-sm";

export const getGoalTextColorClassName = (scope: GoalScope) => {
  let goalColorClassName = "text-blue-500";
  if (scope === GoalScope.Team) {
    goalColorClassName = "text-[#4C34E0]";
  }
  if (scope === GoalScope.Organization) {
    goalColorClassName = "text-[#A42CDC]";
  }
  if (scope === GoalScope.Career || scope === GoalScope.Development) {
    goalColorClassName = "text-[#0D8494]";
  }
  return goalColorClassName;
};

export const listBoxButtonClassName = ({ disabled }: { disabled: boolean }) =>
  classNames(
    "px-2 py-1 text-left text-gray-800 text-sm rounded flex items-center gap-1.5",
    disabled ? "" : "hover:bg-gray-100",
  );
